// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx","978":"12dced5d"}[chunkId] + "-" + {"218":"288cacbf07f00d7f5c50","351":"0b86cdd5bfb1da1dce2a","691":"a24886539739ff4a1db4","978":"e473137e7dc8feded2a6"}[chunkId] + ".js";
};